var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nuxt-link',{class:[
    'tw-relative tw-block tw-h-full tw-no-underline hover:tw-no-underline',
    'card-' + _vm.item.postType,
    { 'tw-block !tw-w-full': !_vm.showExcerpt && !_vm.clampTitle },
  ],attrs:{"to":_vm.item.link,"title":`View ${_vm.item.title}`,"prefetch":false},nativeOn:{"click":function($event){return _vm.$emit('click', _vm.item)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }